<template>
  <div class="columns is-multiline">
    <div class="column is-8">
      <div class="field">
        <label v-if="isCreate" class="label">Project Name</label>
        <div class="control">
          <ValidationProvider rules="required" v-slot="errors">
            <input
              v-model="model.name"
              class="input"
              type="text"
              :disabled="!editing"
            />
            <span class="help">{{ errors.errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
    </div>

    <div class="column is-4">
      <div class="field">
        <label v-if="isCreate" class="label">Date</label>
        <div class="control has-icons-right">
          <input v-model="date" class="input" type="text" :disabled="true" />
          <span class="icon icon-calendar is-small is-right"></span>
        </div>
      </div>
    </div>

    <div class="column is-12">
      <div class="field">
        <label v-if="isCreate" class="label">Description</label>
        <div class="control">
          <input
            v-model="model.description"
            class="input"
            type="text"
            :disabled="!editing"
          />
        </div>
      </div>
    </div>
    <template v-if="isCreate">
      <div class="column is-6">
        <div class="field">
          <label class="label">Association</label>
          <div class="control">
            <ValidationProvider rules="required" v-slot="errors">
              <div class="select">
                <select v-model="model.groupID" :disabled="!editing">
                  <option
                    v-for="r in $store.getters['groups/flatTree']()"
                    :value="r.groupID"
                    :disabled="r.disabled"
                    v-html="r.name"
                    :key="r.groupID"
                  >
                  </option>
                </select>
              </div>
              <span class="help">{{ errors.errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Form from './Form.js';
import { ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import '@/validation.js';

export default {
  name: 'ProjectForm',
  extends: Form,
  props: {
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider
  },
  data() {
    return {
      model: {}
    };
  },
  computed: {
    date() {
      return moment(this.model.createdOnUTC).format('YYYY-MM-DD');
    }
  }
};
</script>
